import React, { useState, useEffect } from 'react';
import { Accordion, Card, Tag } from 'antd-mobile';

import { UrlSearch } from "../../../utils/utils";
import { Loading } from '../../usms/components';
import CompanyInfo from '../../usms/components/CompanyInfo';
import { GetCustomerDetail } from '../../../api/usms';

import { getSmsType } from "../../../page/localStorage";
import { renderDeductTypes } from "../../../utils/utils";

import { ChargeTypeReverseEnum } from '../utils/const';

import DiscountConfig from './DiscountConfig';

export default function CustomerDetailConfig() {

  const [loading, setLoading] = useState(false);
  const [tabType, setTabType] = useState();
  const [companyId, setCompanyId] = useState();
  const [companyInfo, setCompanyInfo] = useState({});

  useEffect(() => {
    initData()
  }, []);

  const initData = () => {
    const id = UrlSearch("id");
    const type = UrlSearch("type");
    setTabType(type);
    setCompanyId(id);
    if (id) {
      getInfo(id);
    }
  }

  const getInfo = companyId => {
    if (companyId) {
      setLoading(true);
      GetCustomerDetail({ CompanyId: +companyId }).then(res => {
        if (res) {
          setCompanyInfo(res.Data || {});
        }
        setLoading(false);
      }).catch(error => {
        console.error(error);
        setLoading(false);
      });
    }
  }

  const customTags = <>
    {renderDeductTypes(companyInfo) ? <Tag color="blue" selected>{renderDeductTypes(companyInfo)}</Tag> : null}
  </>

  return (
    <div className="container">
      <h3 className='mb-10'>{getSmsType() === 'Text' ? 'USMS' : ''} 用户{tabType === 'discount' ? '实时扣费' : ''}配置</h3>
      <Accordion className='list-accordion' style={{ marginBottom: '8px' }}>
        <Accordion.Panel key={'info'} header={<span>客户信息({companyInfo.CompanyEmail})</span>}>
          <Card>
            <Card.Body>
              <CompanyInfo CompanyId={companyId} customTags={customTags} />
            </Card.Body>
          </Card>
        </Accordion.Panel>
      </Accordion>

      <Loading loading={loading}>
        {tabType === 'discount' ?
          <DiscountConfig
            CompanyInfo={companyInfo}
            ChargeType={ChargeTypeReverseEnum['实时扣费']}
          /> : null}
      </Loading>
    </div>
  )
}
